// extracted by mini-css-extract-plugin
module.exports = {"columnas":"HelpList_columnas__ZvUbL","columna":"HelpList_columna__GUUcB","title":"HelpList_title__nU72D"};